import React, { useEffect, useState, useRef } from "react";

import { minutesToMilliseconds } from "date-fns";
import { useHistory } from "react-router-dom";

import {
  PUBLIC_ROUTES,
  WARNING_SHOW_POPUP_AFTER_IN_MIN,
  INTERVAL_AFTER_ONE_MIN,
  IS_TERMINATED,
} from "../../../constants";
import { useAppState } from "../../../context/StateContext";
import ModalSessionComponent from "./ModalSessionComponent";

export const SessionChecker: React.FC<{ utcTime: string; autoTerminateSession?: boolean }> = ({
  utcTime,
  autoTerminateSession = false,
}) => {
  const { userLogout } = useAppState();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [modalShown, setModalShown] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (autoTerminateSession) {
      const checkTimeAndAlert = () => {
        const utcDate = new Date(utcTime);
        const nowUtc = new Date();
        const differenceInMilliSeconds = utcDate.getTime() - nowUtc.getTime();
        const targetDuration = minutesToMilliseconds(WARNING_SHOW_POPUP_AFTER_IN_MIN);

        if (differenceInMilliSeconds <= targetDuration) {
          setOpen(true);
          setModalShown(true);

          if (intervalRef.current) {
            clearInterval(intervalRef.current);
          }
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }

          timeoutRef.current = setTimeout(() => {
            localStorage.setItem(IS_TERMINATED, "true");
            loggedOut();
          }, differenceInMilliSeconds);
        }
      };

      checkTimeAndAlert();

      const intervalDuration = minutesToMilliseconds(INTERVAL_AFTER_ONE_MIN);

      intervalRef.current = setInterval(checkTimeAndAlert, intervalDuration);

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }
  }, [utcTime]);

  const onClose = () => {
    setOpen(false);
    setModalShown(false);
  };

  const loggedOut = () => {
    userLogout();
    setModalShown(false);
    history.replace(PUBLIC_ROUTES.SIGN_IN);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  return (
    <ModalSessionComponent
      open={open && modalShown}
      onClose={onClose}
      loggedOut={loggedOut}
      stayLoggedIn={onClose}
    />
  );
};

export default SessionChecker;
